import { useEffect, useState, useRef, useContext } from "react";
import Icon, {
  SearchOutlined,
  MoreOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  StopOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { showSuccessToast, showErrorToast } from "../ToastHelper";
import {
  Button,
  Form,
  Input,
  Select,
  Space,
  Table,
  Tag,
  Popconfirm,
  Dropdown,
  Modal,
} from "antd";
import {
  getprivileges,
  getUsersList,
  createUserService,
  suspendUserService,
  deleteUserService,
  activateUserService,
} from "../services/userManagementService";
import { AuthTokenContext } from "../context/tokenContext";
import Card from "antd/es/card/Card";
import {
  getUserPrivileges,
  editUserPrivileges,
} from "../services/userPrivilegeService";
import { decrypt, encrypt } from "../utils/encrypt";

function UserManagement() {
  const [token, setToken] = useContext(AuthTokenContext);

  const [userPrivileges, setUserPrivileges] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [selectedPrivileges, setSelectedPrivileges] = useState([]);
  const [loginId, setLoginId] = useState("");
  const [userSavedPrivileges, setUserSavedPrivileges] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [form] = Form.useForm();
  const [selectForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading,setLoading]=useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleEditUserPrivileges = (e) => {
    editUserPrivilegesService(token);
    // setUserSavedPrivileges([]);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setSelectedPrivileges([]);
    setIsModalOpen(false);
  };

  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      // searchedColumn === dataIndex ? (
      //   <Highlighter
      //     highlightStyle={{
      //       backgroundColor: "#ffc069",
      //       padding: 0,
      //     }}
      //     searchWords={[searchText]}
      //     autoEscape
      //     textToHighlight={text ? text.toString() : ""}
      //   />
      // ) : (
      //   text
      // ),
      text,
  });
  function renderActionDropdown(record) {
    const items = [
      {
        label: "Edit User Privileges",
        key: "0",
        icon: <EditOutlined />,
      },
      record.status === "ACT"
        ? {
            label: "Suspend",
            key: "1",
            icon: <StopOutlined />,
          }
        : {
            label: "Activate",
            key: "2",
            icon: <CheckCircleOutlined />,
          },
      {
        label: (
          <Popconfirm
            title="Are you sure delete this user?"
            onConfirm={() => deleteUser(record.loginIdHide)}
            okText="Yes"
            cancelText="No"
          >
            <Icon
              component={DeleteOutlined}
              style={{ verticalAlign: "middle", marginRight: "0.5rem" }}
            />
            Delete
          </Popconfirm>
        ),
        key: "3",
      },
    ];

    const handleMenuClick = (e) => {
      if (e.key === "0") {
        //get privileges by login id service
        setLoginId(record.loginIdHide);
        userPrivilegesService(record.loginIdHide);
      } else if (e.key === "1") {
        suspendUser(record.loginIdHide);
      } else if (e.key === "2") {
        activateUser(record.loginIdHide);
      }
    };
    const menuProps = {
      items,
      onClick: handleMenuClick,
    };
    return (
      <Dropdown menu={menuProps}>
        <Button type="button" size="small" style={{ borderWidth: 0 }}>
          <Icon
            component={MoreOutlined}
            style={{
              fontSize: "20px",
            }}
          />
        </Button>
      </Dropdown>
    );
  }
  const columns = [
  
    {
      title: "Login ID",
      dataIndex: "loginIdMasked",
      key: "loginIdMasked",
      ...getColumnSearchProps("loginIdHide"),
    },
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
      ...getColumnSearchProps("serialNumber"),
    },
    {
      title: "Machine ID",
      dataIndex: "machineId",
      key: "machineId",
      ...getColumnSearchProps("machineId"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      ...getColumnSearchProps("status"),
      render: (_, { status }) => {
        let color = status === "ACT" ? "green" : "gold";
        return (
          <Tag color={color} key={status}>
            <strong>{status.toUpperCase()}</strong>
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) =>
        usersData.length >= 1 ? renderActionDropdown(record) : null,
    },
  ];

  async function privilagesList() {
    try {
      let response = await getprivileges(token);
      setUserPrivileges(response.data);
    } catch (error) {
      showErrorToast(error.message);
    }
  }

  async function userPrivilegesService(loginId) {
    try {
      // setUserSavedPrivileges([]);
      let response = await getUserPrivileges(loginId, token);

      setUserSavedPrivileges(response.data);
      showModal();
    } catch (error) {
      showErrorToast(error.message);
    }
  }

  async function editUserPrivilegesService() {
    const data = {
      loginId: loginId,
      privilegeCode: selectedPrivileges,
    };
    try {
      let response = await editUserPrivileges(data, token);

      if (response.statusCode === 0 && response.statusMsg === "Success") {
        showSuccessToast("User Privileges Changed Successfully");
      }
    } catch (error) {
      showErrorToast(error.message);
    }
  }
  async function usersList() {
    try {
      let response = await getUsersList(token);
      formatData(response.data);
    } catch (error) {
      showErrorToast(error.message);
    }
  }

  async function suspendUser(loginId) {
    try {
      let response = await suspendUserService(loginId, token);
      if (response.statusCode === 0 && response.statusMsg === "Success") {
        showSuccessToast("User Suspended Successfully");
        usersList();
      }
    } catch (error) {
      showErrorToast(error.message);
    }
  }

  async function deleteUser(loginId) {
    try {
      let response = await deleteUserService(loginId, token);
      if (response.statusCode === 0 && response.statusMsg === "Success") {
        showSuccessToast("User Deleted Successfully");
        usersList();
      }
    } catch (error) {
      showErrorToast(error.message);
    }
  }
  async function activateUser(loginId) {
    try {
      let response = await activateUserService(loginId, token);
      if (response.statusCode === 0 && response.statusMsg === "Success") {
        showSuccessToast("User Activated Successfully");
        usersList();
      }
    } catch (error) {
      showErrorToast(error.message);
    }
  }

  async function createUser(values) {
    try {
      setLoading(true)
      let response = await createUserService(values, token);
      setLoading(false)
      if (response.statusCode === 0 && response.statusMsg === "Success") {
        showSuccessToast("User Created Successfully");
        usersList();
      }
      form.resetFields();
    } catch (error) {
      setLoading(false)

      showErrorToast(error.message);
    }
  }

  useEffect(() => {
    privilagesList();
    usersList();
  }, []);
  function maskString(str) {
    console.log(str)
    return str.slice(0, -4).replace(/./g, 'X') + str.slice(-4);
  }

  function formatData(data) {
    const formated_data = [];
    for (var i = 0; i < data.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["loginIdMasked"] = maskString(data[i]["loginId"]);
      row["loginIdHide"]=data[i]["loginId"];
      row["serialNumber"] = data[i]["serialNumber"];
      row["machineId"] = data[i]["machineId"];
      row["status"] = data[i]["status"];
      formated_data.push(row);
    }
    setUsersData(formated_data);
  }

  const options = [];
  userPrivileges.forEach((item) => {
    options.push({
      label: item.privilegeName,
      value: item.privilegeCode,
    });
  });
  
  return (
    <div>
      <Card
        style={{
          marginTop: "10px",
          marginBottom: "30px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
        bordered={false}
      >
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          style={{ marginTop: "2.5rem" }}
          initialValues={{
            remember: true,
          }}
          onFinish={createUser}
          autoComplete="off"
          className="form-style"
        >
          <Form.Item
            label="Login ID"
            name="loginId"
            rules={[
              {
                required: true,
                message: "Please input your Login ID!",
              },
            ]}
          >
            <Input placeholder="Please input your Login ID" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input.Password placeholder="Please input your Password" />
          </Form.Item>
          <Form.Item
            label="PIN"
            name="pin"
            rules={[
              {
                required: true,
                message: "Please input your PIN!",
              },
              {
                pattern: new RegExp("^[0-9]{5}$"),
                message: "5 digits and no space or special characters allowed",
              },
            ]}
          >
            <Input
              type="password"
              placeholder="Please input your PIN"
              maxLength="5"
            />
          </Form.Item>
          <Form.Item
            label="Msisdn"
            name="msisdn"
            rules={[
              {
                required: true,
                message: "Please input your msisdn!",
              },
              {
                pattern: new RegExp("^[7][5][0-9]{8}$"),
                message: "Start with 75 then enter 8 digits",
              },
            ]}
          >
            <Input
              id="msisdn"
              type="text"
              placeholder="75xxxxxxxx"
              maxLength="10"
            />
          </Form.Item>

          <Form.Item
            label="Privilege"
            name="privilege"
            rules={[
              {
                required: true,
                message: "Please select user privilege",
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              style={{
                width: "100%",
              }}
              placeholder="Please select user privilege"
              options={options}
            />
          </Form.Item>

          <Form.Item style={{ float: "right" }}>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
      <Table
        columns={columns}
        dataSource={usersData}
        pagination={{ pageSize: 10 }}
        
      />
      <Modal
        title="Edit User Privileges"
        open={isModalOpen}
        onOk={selectForm.submit}
        // onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={selectForm} onFinish={handleEditUserPrivileges}>
          <Form.Item
            label="Privilege"
            name="privilege"
            rules={[
              {
                required: true,
                message: "Please select user privilege",
              },
            ]}
          >
            <Select
              mode="multiple"
              style={{
                width: "100%",
              }}
              placeholder="Please select user privilege"
              key={userSavedPrivileges}
              defaultValue={userSavedPrivileges}
              onChange={(e) => {
                setSelectedPrivileges(e);
              }}
              options={options}
            ></Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
export default UserManagement;
